import http from "./http";

// Anamnese customizavel por medico (Fase 5). Passa TUDO pelo Laravel (auth
// Bearer), que injeta o doctor_id do medico logado e faz proxy pra comunicacao
// (onde mora a DEFINICAO, nas tabelas questionnaire_*). O frontend so troca o
// "editor shape" do prototipo — o Laravel/comunicacao cuidam da traducao.

/**
 * Lista os templates visiveis: a(s) anamnese(s) Padrao (imutaveis) + as
 * personalizadas do medico logado.
 * @returns {Promise<Array<object>>} templates em editor shape.
 */
export async function listAnamneseTemplates() {
  const { data } = await http.get("/api/anamnese-templates");
  return data.templates || [];
}

/**
 * Cria uma nova anamnese personalizada.
 * @param {object} template Editor shape ({name, questions:[...]}).
 * @returns {Promise<object>} template criado (com id).
 */
export async function createAnamneseTemplate(template) {
  const { data } = await http.post("/api/anamnese-templates", template);
  return data.template;
}

/**
 * Substitui a definicao de uma anamnese personalizada.
 * @param {string} id
 * @param {object} template Editor shape.
 * @returns {Promise<object>} template atualizado.
 */
export async function updateAnamneseTemplate(id, template) {
  const { data } = await http.put(`/api/anamnese-templates/${id}`, template);
  return data.template;
}

/**
 * Exclui uma anamnese personalizada.
 * @param {string} id
 */
export async function deleteAnamneseTemplate(id) {
  await http.delete(`/api/anamnese-templates/${id}`);
}

/**
 * Liga/desliga a anamnese no perfil do medico (quais aparecem pra solicitar).
 * @param {string} id
 * @param {boolean} active
 * @returns {Promise<object>} {id, active}.
 */
export async function setAnamneseTemplateActive(id, active) {
  const { data } = await http.patch(`/api/anamnese-templates/${id}/active`, {
    active,
  });
  return data;
}
